var DataBehavior = require('backbone-torso/modules/behaviors/DataBehavior');
var storedPaymentMethodCollection = require('./storedPaymentMethodCollection');

/**
 * Data Behavior hooked up to the stored payment method cache.
 * @class StoredPaymentMethodDataBehavior
 * @constructor
 */
module.exports = DataBehavior.extend({
  cache: storedPaymentMethodCollection
});
